import {
  apiGetUser,
} from '@/functions/api'

import {
  getLanguageCode,
} from '@/functions/languageCode'

export function loadProfile(id) {
  if (Number.isNaN(id)) {
    return Promise.resolve({
      ok: false,
      error: {
        code: 400,
        name: 'PARAM_ID_INVALID'
      }
    })
  }
  return apiGetUser(id, getLanguageCode())
}
